import styled from 'styled-components';

export const NotificationContainer = styled.div`
  .checked {
    opacity: 0.5;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  justify-content: center;
`;
